import React from 'react';
import { FaComments, FaShieldAlt } from 'react-icons/fa';
import CommsAdminPanel from './CommsAdminPanel';

export default function CommsRules() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
          <FaComments className="text-indigo-600" />
          Communication rules
        </h1>
        <p className="text-sm text-slate-500 mt-1 max-w-2xl">
          Masked order chat, violation escalation, package-contact strikes, and order-thread review.
          Buyer and seller contact details are never exchanged in-app.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-600 flex items-start gap-3">
        <FaShieldAlt className="text-indigo-500 mt-0.5 shrink-0" />
        <ul className="list-disc pl-4 space-y-1">
          <li>Chat opens at seller accept; closes at order complete.</li>
          <li>2nd contact violation → 7-day chat ban + auto support ticket.</li>
          <li>Shipping label PDF is the only place sellers see full buyer address/phone.</li>
          <li>SMS, email, and push notifications are sanitized — no contact info leaked.</li>
        </ul>
      </div>

      <CommsAdminPanel />
    </div>
  );
}
